import { SxProps, Theme, alpha } from '@mui/material';

/**
 * Styles for SelectComponent
 * Uses theme values from MuiProvider for consistent styling
 */

export const selectComponentStyles = {
  formControl: (theme: Theme, fontSize = theme.typography.body1.fontSize) => ({
    '& .MuiInputLabel-root': {
      color: theme.palette.text.secondary,
      fontSize,
      '&.Mui-focused': {
        color: theme.palette.primary.main,
      },
    },
  }) as SxProps<Theme>,

  select: (theme: Theme, fontSize = theme.typography.body1.fontSize) => ({
    fontSize,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.divider,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
      borderWidth: '2px',
    },
    '& .MuiSelect-select': {
      padding: '10px 14px',
    },
  }) as SxProps<Theme>,

  menuItem: (theme: Theme, fontSize = theme.typography.body1.fontSize) => ({
    fontSize,
    color: theme.palette.text.primary,
    padding: '8px 16px',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '&.Mui-selected': {
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.15),
      },
    },
  }) as SxProps<Theme>,

  checkbox: (theme: Theme) => ({
    color: theme.palette.divider,
    '&.Mui-checked': {
      color: theme.palette.primary.main,
    },
  }) as SxProps<Theme>,

  listItemText: (theme: Theme, fontSize = theme.typography.body1.fontSize) => ({
    '& .MuiListItemText-primary': {
      fontSize,
      color: theme.palette.text.primary,
    },
  }) as SxProps<Theme>,
};

// Menu props for the Select dropdown
export const selectMenuProps = (theme: Theme) => ({
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'left' as const,
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const,
  },
  PaperProps: {
    sx: {
      maxHeight: 300,
      boxShadow: theme.shadows[4],
      borderRadius: `${theme.shape.borderRadius}px`,
      marginTop: '4px',
    },
  },
});

export default selectComponentStyles;
